var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var style = require('./Gallery.less');

module.exports = Backbone.View.extend({
    el: '.Gallery',

    events: {
        'click .Gallery-close': 'closeGallery'
    },

    show: function (slider) {
        this.sliderView = slider;

        this.$sliderItems = this.sliderView.$el.find('.owl-item:not(.cloned) .BlockGallery-item');
        this.slideIndex = this.sliderView.pageIndex;

        this.$el.fadeIn();
        app.els.$body.addClass('u-NoScroll');
        this.renderGalleryItems();
        this.initFullscreenGallery();
    },

    renderGalleryItems: function () {
        var self = this;
        //приходятся контейнеры для карусели и превьюх создавать через ЖС, потому что у Owl есть баг с
        //destroy.owl.carousel

        var $gallerySlider = $('<div>').addClass('Gallery-slider owl-carousel');

        this.$el.prepend($gallerySlider);

        this.$gallerySlider = this.$('.Gallery-slider');
        this.$prev = this.$('.Gallery-prev');
        this.$next = this.$('.Gallery-next');

        this.$sliderItems.each(function (index, item) {
            var galleryItem = $('<img>').addClass('Gallery-sliderItem')
                .attr('src', $(item).attr('src'))
                .attr('srcset', $(item).attr('srcset'));

            self.$gallerySlider.append(galleryItem);
        });
    },

    initFullscreenGallery: function () {
        var self = this;
        var flag = false;
        var duration = 300;

        this.$gallerySlider.owlCarousel({
            items: 1,
            mouseDrag: true,
            lazyLoad: true,
            loop: true,
            nav: false,
            autoplay: false,
            slideBy: 'page',
            startPosition: self.slideIndex
        })
            .on('changed.owl.carousel', function (e) {
                if (!flag) {
                    flag = true;
                    self.slideIndex = e.page.index;
                    flag = false;
                }
            });

        this.$prev.on('click', function () {
            this.$gallerySlider.trigger('prev.owl.carousel');
        }.bind(this));

        this.$next.on('click', function () {
            this.$gallerySlider.trigger('next.owl.carousel');
        }.bind(this));
    },

    closeGallery: function () {
        this.$el.fadeOut(400, function () {
            this.$gallerySlider.trigger('remove.owl.carousel').empty();
            this.$gallerySlider.remove();
        }.bind(this));

        app.els.$body.removeClass('u-NoScroll');

        this.sliderView.showSlide(this.slideIndex);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Gallery/Gallery.js
// module id = 24
// module chunks = 0